/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConversionPixel } from '../models/ConversionPixel';
import type { ConversionPixelRequest } from '../models/ConversionPixelRequest';
import type { PaginatedConversionPixelList } from '../models/PaginatedConversionPixelList';
import type { PatchedConversionPixelRequest } from '../models/PatchedConversionPixelRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConversionPixelsService {

    /**
     * @returns PaginatedConversionPixelList
     * @throws ApiError
     */
    public static conversionPixelsList({
        brand,
        page,
        pageSize,
        search,
    }: {
        brand?: string,
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedConversionPixelList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/conversion_pixels/',
            query: {
                'brand': brand,
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ConversionPixel
     * @throws ApiError
     */
    public static conversionPixelsCreate({
        requestBody,
    }: {
        requestBody: ConversionPixelRequest,
    }): CancelablePromise<ConversionPixel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/conversion_pixels/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConversionPixel
     * @throws ApiError
     */
    public static conversionPixelsRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<ConversionPixel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/conversion_pixels/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ConversionPixel
     * @throws ApiError
     */
    public static conversionPixelsPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedConversionPixelRequest,
    }): CancelablePromise<ConversionPixel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v3/conversion_pixels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static conversionPixelsDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v3/conversion_pixels/{id}',
            path: {
                'id': id,
            },
        });
    }

}
